import { useEffect, useMemo, useState } from "react"

import { App, Flex, Form, Grid, Layout, Space, Spin, Typography } from "antd"
import { useTranslation } from "react-i18next"
import ReactPlayer from "react-player"
import { connect } from "react-redux"
import { useParams } from "react-router"
import { useLocation, useNavigate } from "react-router-dom"

import ButtonComponent from "../Components/Button"
import BillingDescriptorsForm from "../Components/Forms/BillingDescriptorsForm"
import BillingDescriptorsFormConfigure from "../Components/Forms/BillingDescriptorsFormConfigure"
import LoginHeader from "../Components/LoginHeader"
import LogOutText from "../Components/LogOutText"
import PrivacyPolicy from "../Components/PrivacyPolicy"
import StepTitle from "../Components/StepTitle/StepTitle"
import Icon from "../Icon"
import Images from "../Images"
import { modalConfig } from "../theme"
import utils from "../Utils/utils"
//import {createAccountStepPath, onboardingStepPath} from '../Utils/utils'

import UserActions from "./User/reducer"

const { Title, Text } = Typography
const { useBreakpoint } = Grid

const videoMap = {
  stripe: "https://www.youtube.com/watch?v=aHwIs8yyCgM",
  shopify: "https://www.youtube.com/watch?v=LJuGyO0_INk",
  braintree: "https://www.youtube.com/watch?v=LzPpwDxMuzs",
  chargebee: "https://www.youtube.com/watch?v=LzPpwDxMuzs",
  recurly: "https://www.youtube.com/watch?v=7uW-Csf4xBs",
  airwallex: "https://www.youtube.com/watch?v=La3SaBYcbJY",
  "authorize.net": "https://www.youtube.com/watch?v=Qh0i_zjyB5U",
  nmi: "https://www.youtube.com/watch?v=K0M99mEfBdk",
  next: "https://www.youtube.com/watch?v=7pliUWD8IzQ",
  manual_refunds: "https://www.youtube.com/watch?v=xKa7Eg4fD5o",
  default: "https://www.youtube.com/watch?v=K0M99mEfBdk"
}

function OnboardingAlertsPage(props) {
  const {
    auth: { error, fetching, userInfo, isAdmin },
    nav: { isMobile, theme },
    userFetching,
    adminSelectedBusinessAccountId,
    businessAccount,
    paymentProcessors,
    enrollments,
    nextCreateAccountStep,
    isManualRefundsConnected,
    billingDescriptors,
    errorDescriptors,
    errorBinCodes,
    errorCaidCodes,
    step,
    maxStep
  } = props

  const { enrollmentId } = useParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const { modal } = App.useApp()

  const { sm, lg } = useBreakpoint()

  //show modal
  const [visible, setVisible] = useState(false)
  const [videoUrl, setVideoUrl] = useState("")

  const businessId = isAdmin
    ? adminSelectedBusinessAccountId
    : nextCreateAccountStep
      ? businessAccount?.id
      : userInfo?.["current_business_account_id"]
  const selectedPayment = paymentProcessors
    ?.filter((pp) => pp?.["is_connected"])
    ?.map((pp) => pp?.["service_name"])
  const activeEnrollments = [...enrollments?.filter((enrollment) => enrollment.is_active)]
  const activeEnrollmentsId = [
    ...enrollments?.filter((enrollment) => enrollment.is_active)?.map((el) => el.id)
  ]
  const activeEnrollmentsHash = enrollmentId || activeEnrollmentsId?.join(",")
  const isActiveRDR = enrollmentId
    ? enrollments?.find((el) => el.id === enrollmentId)?.name === "RDR"
    : activeEnrollments?.some((enrollment) => enrollment.name === "RDR")
  const isCreatingBa = !userInfo?.new_onboarding_finished || nextCreateAccountStep
  const isConfigureEnrollment =
    pathname.includes("/configure/enrollment") || pathname.includes("business_settings/enrollment/")

  const initialValues = useMemo(() => {
    const billingDescriptorsNotEmpty = billingDescriptors?.descriptor_data?.filter(
      (el) => el?.["merchant_descriptor"]
    )
    const billingDescriptorsList = billingDescriptorsNotEmpty?.map(
      (el) => el["merchant_descriptor"]
    )
    const temporaryDescriptorsList = billingDescriptorsNotEmpty
      ?.filter((el) => el?.["is_temporary"])
      ?.map((el) => el["merchant_descriptor"])
    const allVisaArnCodesList =
      billingDescriptorsNotEmpty?.flatMap((el) => el["visa_arn_codes"]) || []
    const visaArnCodesList = [...new Set(allVisaArnCodesList)]
    const allVisaBinCodesList =
      billingDescriptorsNotEmpty?.flatMap((el) => el["visa_bin_codes"]) || []
    const visaBinCodesList = [...new Set(allVisaBinCodesList)]
    const allVisaCaidCodesList =
      billingDescriptorsNotEmpty?.flatMap((el) => el["visa_caid_codes"]) || []
    const visaCaidCodesList = [...new Set(allVisaCaidCodesList)]

    return {
      merchant_descriptor: billingDescriptorsList || [],
      temporary_descriptor: temporaryDescriptorsList || [],
      visa_arn_codes: visaArnCodesList || [],
      // dont_remember_descriptors: billingDescriptors?.dont_remember_descriptors,
      // dont_remember_arn_codes: billingDescriptors?.dont_remember_arn_codes,
      visa_bin_codes: visaBinCodesList || [],
      visa_caid_codes: visaCaidCodesList || [],
      use_bin_caid_codes: billingDescriptors?.use_bin_caid_codes || false
      // dont_remember_bin_codes: billingDescriptors?.dont_remember_bin_codes,
      // dont_remember_caid_codes: billingDescriptors?.dont_remember_caid_codes,
    }
  }, [billingDescriptors])

  useEffect(() => {
    // if(billingDescriptors?.dont_remember_descriptors) form.setFieldValue('dont_remember_descriptors', true)
    // if(billingDescriptors?.dont_remember_arn_codes) form.setFieldValue('dont_remember_arn_codes', true)
    if (billingDescriptors?.visa_arn_codes?.length)
      form.setFieldValue(
        "visa_arn_codes",
        billingDescriptors?.visa_arn_codes.map((el) => el["arn_code"])
      )

    if (billingDescriptors?.use_bin_caid_codes) form.setFieldValue("use_bin_caid_codes", true)
    if (billingDescriptors?.visa_bin_codes?.length)
      form.setFieldValue(
        "visa_bin_codes",
        billingDescriptors?.visa_bin_codes.map((el) => el["bin_code"])
      )
    if (billingDescriptors?.visa_caid_codes?.length)
      form.setFieldValue(
        "visa_caid_codes",
        billingDescriptors?.visa_caid_codes.map((el) => el["caid_code"])
      )
    // if(billingDescriptors?.dont_remember_bin_codes) form.setFieldValue('dont_remember_bin_codes', true)
    // if(billingDescriptors?.dont_remember_caid_codes) form.setFieldValue('dont_remember_caid_codes', true)
  }, [billingDescriptors])

  useEffect(() => {
    if (selectedPayment.length === 1) {
      setVideoUrl(videoMap[selectedPayment[0]] || videoMap["default"])
    } else if (selectedPayment.length > 1) {
      setVideoUrl(videoMap["default"])
    }
  }, [selectedPayment])

  // const handleCheckToContinue = () => {
  //   const formValues = form.getFieldsValue();
  //   if (!formValues?.use_bin_caid_codes) {
  //     if (!formValues?.merchant_descriptor || (!formValues?.visa_arn_codes)) {
  //       if (!formValues?.merchant_descriptor) {
  //         form.setFieldValue('dont_remember_descriptors', true)
  //       }
  //       if (!formValues?.visa_arn_codes) {
  //         form.setFieldValue('dont_remember_arn_codes', true)
  //       }
  //       openModalConfirm();
  //     } else {
  //       handleSubmit()
  //     }
  //   } else {
  //     if (!formValues?.merchant_descriptor || !formValues?.visa_bin_codes || !formValues?.visa_caid_codes) {
  //       if (!formValues?.merchant_descriptor) {
  //         form.setFieldValue('dont_remember_descriptors', true)
  //       }
  //       if (!formValues?.visa_bin_codes) {
  //         form.setFieldValue('dont_remember_bin_codes', true)
  //       }
  //       if (!formValues?.visa_caid_codes) {
  //         form.setFieldValue('dont_remember_caid_codes', true)
  //       }
  //       openModalConfirm();
  //     } else {
  //       handleSubmit()
  //     }
  //   }
  // }

  const openModalConfirm = () => {
    modal.confirm({
      ...modalConfig("info"),
      centered: !isMobile,

      title: t("We are missing some information..."),
      content: (
        <Text type="secondary">
          {t(
            "Warning, you have not provided us with enough information to turn on chargeback prevention for your account."
          )}
        </Text>
      ),
      cancelText: t("Cancel"),
      okText: t("Continue anyway"),
      cancelButtonProps: { size: "large" },
      okButtonProps: { size: "large" },
      onOk() {
        //if user confirm to continue, set the "dont_remember" fields according to empty fields
        // const formValues = form.getFieldsValue();
        // if (!formValues?.use_bin_caid_codes) {
        //   if (!formValues?.merchant_descriptor || (!formValues?.visa_arn_codes)) {
        //     if (!formValues?.merchant_descriptor) {
        //       form.setFieldValue('dont_remember_descriptors', true)
        //     }
        //     if (!formValues?.visa_arn_codes) {
        //       form.setFieldValue('dont_remember_arn_codes', true)
        //     }
        //   }
        // } else if (!formValues?.merchant_descriptor || !formValues?.visa_bin_codes || !formValues?.visa_caid_codes) {
        //   if (!formValues?.merchant_descriptor) {
        //     form.setFieldValue('dont_remember_descriptors', true)
        //   }
        //   if (!formValues?.visa_bin_codes) {
        //     form.setFieldValue('dont_remember_bin_codes', true)
        //   }
        //   if (!formValues?.visa_caid_codes) {
        //     form.setFieldValue('dont_remember_caid_codes', true)
        //   }
        // }
        //then submit the form
        handleSubmit({ not_validate: true })
      },
      onCancel() {}
    })
  }

  const handleSubmit = async ({ not_validate }) => {
    try {
      const merchant_descriptor = form.getFieldValue("merchant_descriptor") ?? []
      const visa_arn_codes = form.getFieldValue("visa_arn_codes") ?? []
      const visa_bin_codes = form.getFieldValue("visa_bin_codes") ?? []
      const visa_caid_codes = form.getFieldValue("visa_caid_codes") ?? []
      // const dont_remember_descriptors = form.getFieldValue('dont_remember_descriptors') ?? false;
      // const dont_remember_arn_codes = form.getFieldValue('dont_remember_arn_codes') ?? false;
      // const dont_remember_bin_codes = form.getFieldValue('dont_remember_bin_codes') ?? false;
      // const dont_remember_caid_codes = form.getFieldValue('dont_remember_caid_codes') ?? false;
      const use_bin_caid_codes = form.getFieldValue("use_bin_caid_codes")

      await form.validateFields([
        ...(not_validate ? [] : ["merchant_descriptor"]),
        // 'dont_remember_descriptors',
        ...(not_validate ? [] : ["visa_arn_codes"]),
        // 'dont_remember_arn_codes',
        "use_bin_caid_codes",
        ...(not_validate ? [] : ["visa_bin_codes"]),
        ...(not_validate ? [] : ["visa_caid_codes"])
        // 'dont_remember_bin_codes',
        // 'dont_remember_caid_codes'
      ])

      const visaArnCodesArray = Array.isArray(billingDescriptors?.visa_arn_codes)
        ? billingDescriptors.visa_arn_codes
        : []

      let deleted_visa_arn_codes = visaArnCodesArray.filter(
        (code) => !visa_arn_codes?.includes(code?.["arn_code"])
      )

      if (enrollmentId) {
        if (
          (initialValues?.["merchant_descriptor"].join("") === [...merchant_descriptor].join("") &&
            initialValues?.["visa_arn_codes"].join("") === [...visa_arn_codes].join("") &&
            !use_bin_caid_codes) ||
          (initialValues?.["merchant_descriptor"].join("") === [...merchant_descriptor].join("") &&
            initialValues?.["visa_bin_codes"].join("") === [...visa_bin_codes].join("") &&
            initialValues?.["visa_caid_codes"].join("") === [...visa_caid_codes].join("") &&
            use_bin_caid_codes)
        ) {
          let enrollmentPage = pathname.split("/").slice(0, -2).join("/")
          props.clearStep()
          navigate(enrollmentPage, { replace: true })
        } else {
          let finalDescriptorList = merchant_descriptor
            // .filter(el => (initialValues?.['visa_arn_codes']?.join('') === [...visa_arn_codes]?.join('')) || !isActiveRDR ? !initialValues?.['merchant_descriptor']?.includes(el) : true)
            // .filter(el => ((initialValues?.['visa_arn_codes']?.join('') === [...visa_arn_codes]?.join('')) && !use_bin_caid_codes) || !isActiveRDR ? !initialValues?.['merchant_descriptor']?.includes(el) : true)
            .map((el) => ({
              account_id: businessId,
              merchant_descriptor: el,
              enrollments: [enrollmentId],
              visa_arn_codes,
              ...(billingDescriptors?.visa_arn_codes?.length &&
                deleted_visa_arn_codes?.length && { deleted_visa_arn_codes }),
              visa_bin_codes: use_bin_caid_codes ? visa_bin_codes : [],
              visa_caid_codes: use_bin_caid_codes ? visa_caid_codes : [],
              use_bin_caid_codes
            }))

          if (!finalDescriptorList.length) {
            finalDescriptorList = isAdmin
              ? []
              : [
                  {
                    account_id: businessId,
                    merchant_descriptor: null,
                    enrollments: [enrollmentId],
                    visa_arn_codes,
                    ...(billingDescriptors?.visa_arn_codes?.length &&
                      deleted_visa_arn_codes?.length && { deleted_visa_arn_codes }),
                    visa_bin_codes: use_bin_caid_codes ? visa_bin_codes : [],
                    visa_caid_codes: use_bin_caid_codes ? visa_caid_codes : [],
                    use_bin_caid_codes
                  }
                ]
          }

          let deleteDescriptorList = [...initialValues?.["merchant_descriptor"]]
            ?.filter((el) => !merchant_descriptor?.includes(el))
            .map((el) => ({
              account_id: businessId,
              merchant_descriptor: el,
              enrollments: [enrollmentId],
              is_delete: true,
              ...(billingDescriptors?.visa_arn_codes?.length &&
                deleted_visa_arn_codes?.length && { deleted_visa_arn_codes })
            }))

          const data = {
            forEnrollment: true,
            isAdmin,
            ...(isAdmin && { ba_id: businessId }),
            enrollmentId,
            descriptorList: [...finalDescriptorList, ...deleteDescriptorList]
            // use_bin_caid_codes,
          }
          // console.log('createBillingDescriptor 1', data)
          props.createBillingDescriptor(data)
        }
      } else {
        let finalDescriptorList = merchant_descriptor.map((el) => ({
          account_id: businessId,
          merchant_descriptor: el,
          enrollments: activeEnrollmentsId,
          visa_arn_codes,
          ...(billingDescriptors?.visa_arn_codes?.length &&
            deleted_visa_arn_codes?.length && { deleted_visa_arn_codes }),
          visa_bin_codes: use_bin_caid_codes ? visa_bin_codes : [],
          visa_caid_codes: use_bin_caid_codes ? visa_caid_codes : []
        }))

        const data = {
          dont_remember_descriptors: merchant_descriptor?.length ? false : true,
          dont_remember_arn_codes: !visa_arn_codes?.length ? true : false,
          use_bin_caid_codes,
          dont_remember_bin_codes: !visa_bin_codes?.length ? true : false,
          dont_remember_caid_codes: !visa_caid_codes?.length ? true : false,
          descriptor_data: !finalDescriptorList?.length
            ? [
                {
                  account_id: businessId,
                  merchant_descriptor: null,
                  enrollments: activeEnrollmentsId,
                  visa_arn_codes,
                  ...(billingDescriptors?.visa_arn_codes?.length &&
                    deleted_visa_arn_codes?.length && { deleted_visa_arn_codes }),
                  visa_bin_codes: use_bin_caid_codes ? visa_bin_codes : [],
                  visa_caid_codes: use_bin_caid_codes ? visa_caid_codes : []
                }
              ]
            : [...finalDescriptorList]
        }
        // console.log('createBillingDescriptor 2', data)
        props.createBillingDescriptor(data)
      }
    } catch (errorInfo) {
      console.log("Failed:", errorInfo)
      if (isCreatingBa) {
        const visaArnErrors = errorInfo.errorFields?.filter(
          (errorField) => errorField.name?.[0] === "visa_arn_codes"
        )

        const visaBinErrors = errorInfo.errorFields?.filter(
          (errorField) => errorField.name?.[0] === "visa_bin_codes"
        )

        const visaCaidErrors = errorInfo.errorFields?.filter(
          (errorField) => errorField.name?.[0] === "visa_caid_codes"
        )

        const hasVisaArnErrors =
          visaArnErrors?.length > 0 && visaArnErrors.some((error) => error.errors?.length > 0)

        const hasVisaBinErrors =
          visaBinErrors?.length > 0 && visaBinErrors.some((error) => error.errors?.length > 0)

        const hasVisaCaidErrors =
          visaCaidErrors?.length > 0 && visaCaidErrors.some((error) => error.errors?.length > 0)

        const use_bin_caid_codes = form.getFieldValue("use_bin_caid_codes")
        const visa_bin_codes = form.getFieldValue("visa_bin_codes")
        const visa_caid_codes = form.getFieldValue("visa_caid_codes")
        const visa_arn_codes = form.getFieldValue("visa_arn_codes")

        if (
          !use_bin_caid_codes &&
          (!hasVisaArnErrors || (hasVisaArnErrors && !visa_arn_codes?.length))
        ) {
          openModalConfirm()
        } else if (
          use_bin_caid_codes &&
          (!hasVisaBinErrors || (hasVisaBinErrors && !visa_bin_codes?.length)) &&
          (!hasVisaCaidErrors || (hasVisaCaidErrors && !visa_caid_codes?.length))
        ) {
          openModalConfirm()
        } else {
          console.log("Visa bin codes errors:", visaBinErrors)
          console.log("Visa caid codes errors:", visaCaidErrors)
          console.log("Modal not opened due to validation errors")
        }
      }
    }
  }

  useEffect(() => {
    document.title = "Alerts - Chargeback"
  }, [])

  useEffect(() => {
    if (activeEnrollmentsHash) props.getBillingDescriptors({ enrollments: activeEnrollmentsHash })
  }, [activeEnrollmentsHash])

  useEffect(() => {
    if (billingDescriptors?.descriptor_data?.length) form.setFieldsValue({ ...initialValues })
  }, [billingDescriptors])

  useEffect(() => {
    if (businessId) {
      props.getEnrollments(businessId)
    }
  }, [businessId])

  const isBussinessSettingsPage = pathname?.includes("business_settings")

  return (
    <Layout>
      <Spin size="large" spinning={fetching}>
        <div className="login-row">
          <LoginHeader />
          <div className="login-content">
            <div className="content-main sign-up">
              {enrollmentId ? (
                <div style={{ height: 32 }} />
              ) : (
                <StepTitle step={step} maxStep={maxStep} />
              )}

              <Flex
                vertical
                align={"center"}
                style={{
                  margin: "0 0 auto",
                  width: "100%",
                  maxWidth: 1040,
                  padding: "0 24px",
                  height: isBussinessSettingsPage ? "auto" : "calc(100vh - 72px - 80px - 68px)",
                  overflow: isBussinessSettingsPage ? "none" : "auto"
                }}
              >
                <Flex
                  gap={16}
                  justify="space-between"
                  align="center"
                  style={{ width: "100%" }}
                  wrap="wrap"
                >
                  <Space direction="vertical" size={0}>
                    <Title level={5} style={{ width: 320, textAlign: "left" }}>
                      {t("Alerts activation")}
                    </Title>
                    <Text type={"secondary"} style={{ width: 320 }}>
                      {t("To activate alerts, submit your billing descriptor.")}
                    </Text>
                  </Space>

                  <Flex gap={12}>
                    <ButtonComponent
                      className={"flex center small-space"}
                      block
                      onClick={() =>
                        utils.goLink(
                          "https://help.chargeback.io/en/collections/16516790-setting-up-enrollments",
                          "_blank"
                        )
                      }
                      style={{ padding: "4px 20px" }}
                    >
                      {t("Learn more")}
                      <Icon role="icon" type="edit" style={{ fontSize: 20, color: "#7A7A83" }} />
                    </ButtonComponent>
                  </Flex>
                </Flex>

                <Flex gap={32} vertical style={{ width: "100%", marginTop: 24, minHeight: 320 }}>
                  <Flex gap={isMobile ? 0 : 32} justify="space-between" wrap="wrap-reverse">
                    <Flex
                      gap={20}
                      vertical
                      style={{ width: lg ? "43%" : "100%", maxWidth: lg ? 421 : "100%" }}
                    >
                      <div>
                        {!isMobile && (
                          <Title level={5} style={{ textAlign: "left", marginBottom: 24 }}>
                            <img src={Images.code_lines} alt="" style={{ marginTop: -4 }} />
                            {"  "}
                            {t("Connect")}
                          </Title>
                        )}
                        <Text strong>
                          {t("How to find billing descriptors and ARNs with Stripe")}
                        </Text>
                        <div
                          style={{
                            borderRadius: 12,
                            overflow: "hidden",
                            height: lg || sm ? 237 : 370,
                            marginTop: 12
                          }}
                        >
                          <ReactPlayer
                            controls={true}
                            width={"100%"}
                            height={"100%"}
                            playing={false}
                            url={videoUrl}
                          />
                        </div>
                      </div>
                    </Flex>

                    <div style={{ flex: "0 1 523px", paddingTop: 8 }}>
                      {isConfigureEnrollment ? (
                        <BillingDescriptorsFormConfigure
                          isActiveRDR={isActiveRDR}
                          onSubmit={handleSubmit}
                          form={form}
                          defaultValue={initialValues}
                          isAdmin={isAdmin}
                          errorDescriptors={errorDescriptors}
                          errorBinCodes={errorBinCodes}
                          errorCaidCodes={errorCaidCodes}
                          theme={theme}
                          createBA={isCreatingBa}
                          selectedPayment={selectedPayment}
                        />
                      ) : (
                        <BillingDescriptorsForm
                          isActiveRDR={isActiveRDR}
                          onSubmit={handleSubmit}
                          form={form}
                          defaultValue={initialValues}
                          isAdmin={isAdmin}
                          errorDescriptors={errorDescriptors}
                          errorBinCodes={errorBinCodes}
                          errorCaidCodes={errorCaidCodes}
                          theme={theme}
                          createBA={isCreatingBa}
                          selectedPayment={selectedPayment}
                        />
                      )}
                    </div>
                  </Flex>
                  <Flex justify="center" style={{ width: "100%" }}>
                    <ButtonComponent
                      type="primary"
                      size="large"
                      loading={userFetching}
                      // onClick={handleCheckToContinue}
                      onClick={handleSubmit}
                      className={"flex center"}
                      style={{ width: 320, marginTop: "auto" }}
                    >
                      {t("Continue")}
                    </ButtonComponent>
                  </Flex>
                </Flex>
              </Flex>

              <PrivacyPolicy />
              {!userInfo?.new_onboarding_finished && <LogOutText />}
            </div>
          </div>
        </div>
      </Spin>
    </Layout>
  )
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  nav: state.nav,
  userFetching: state.user.fetching,
  businessAccountFetching: state.user.businessAccountFetching,
  businessAccount: state.user.businessAccount,
  businessAccounts: state.user.businessAccounts,
  enrollments: state.user.enrollments,
  billingDescriptors: state.user.billingDescriptors,
  errorDescriptors: state.user.errorDescriptors,
  errorBinCodes: state.user.errorBinCodes,
  errorCaidCodes: state.user.errorCaidCodes,
  paymentProcessors: state.user.paymentProcessors,

  nextCreateAccountStep: state.user.nextCreateAccountStep,
  isManualRefundsConnected: state.user.isManualRefundsConnected,

  adminSelectedBusinessAccountId: state.user.admin_selected_business_account_id
})

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  getEnrollments: (businessAccountId) =>
    dispatch(UserActions.getEnrollmentsRequest(businessAccountId)),
  getBillingDescriptors: (params) => dispatch(UserActions.getBillingDescriptorsRequest(params)),
  createBillingDescriptor: (data) => dispatch(UserActions.createBillingDescriptorRequest(data)),
  clearStep: () => dispatch(UserActions.userSetProp("nextManageEnrollmentStep", null))
})

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingAlertsPage)
